module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./hotelDetailsWidget.schema.json"));
	}, "validators");
}


//////////////////
// WEBPACK FOOTER
// ./src/widget/hotelDetailsWidget.schema.json
// module id = 241
// module chunks = 1